import { createContext } from "react";

export interface LocationControlSettings {
  apiKey: string;
  provider: "mapbox" | "pelias";
  baseUrl: string;
}

export const LocationControlSettingsContext = createContext<LocationControlSettings>({
  apiKey: "",
  provider: "pelias",
  baseUrl: "",
});
